import { Button } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import { displayAndPluralize } from '@webapps/utils';
import AlertMessage from 'pages/CFA/components/AlertMessage';
import InformationSend from './InformationSend';
import InformationGenerate from './InformationGenerate';
import InformationSign from './InformationSign';
import { useState } from 'react';
import InformationAddBusiness from './InformationAddBusiness';

const Informations = ({ opcoRecord, refetch, totalInvalid, setTabValue, setOpenAddEmployerAccordion }) => {
  const { classes, css, cx, global } = useStyles(styles);

  const [generate, setGenerate] = useState(false);

  const handleAddBusinessClick = () => {
    setTabValue("2");
    setOpenAddEmployerAccordion(true);
  };

  return (
    <div className={cx(global.fcjs, css({ gap: 10 }))}>
      {opcoRecord?.contract && !opcoRecord?.contract?.cfaSignAction && opcoRecord?.contract?.cfaSignAction != "SIGNED" && (
        opcoRecord?.businessContract?.business &&
        <InformationSign opcoRecord={opcoRecord} refetch={refetch} />
      )}
      {!(opcoRecord?.businessEmployer) && (
        <InformationAddBusiness handleClick={handleAddBusinessClick} opcoRecord={opcoRecord} />
      )}
      {opcoRecord?.opcoStatus === 'READY' && !opcoRecord?.contract && (
        <InformationGenerate opcoRecord={opcoRecord} refetch={refetch} toGenerate={generate} />
      )}
      {opcoRecord?.contract?.status === 'ARCHIVED' && opcoRecord?.opcoStatus === "PENDING" && (
        <InformationSend opcoRecord={opcoRecord} refetch={refetch} />
      )}
      {totalInvalid > 0 && (
        <AlertMessage>
          <div className={cx(global.fracjb, css({ width: "100%" }))}>
            <div className={global.alertErrorText}>La convention de formation et le CERFA ne sont pas complets <strong>{`(${displayAndPluralize(totalInvalid, 'champ', 'champs')})`}</strong></div>
            <Button className={classes.errorButton} onClick={() => setTabValue("2")}>Compléter</Button>
          </div>
        </AlertMessage>
      )}
      {opcoRecord?.errors?.length > 0 && ["ERROR-CERFA-UPLOAD", "ERROR-CONTRACT-UPLOAD", "ERROR-CONVENTION-UPLOAD", "FORBIDDEN"].includes(opcoRecord?.opcoStatus) && (
        <AlertMessage align='top'>
          <div className={global.fcjs}>
            <div className={global.alertErrorText}><strong>Une erreur indépendante de notre volonté est survenue.</strong></div>
            <div className={global.alertErrorText}>Notre équipe technique a été automatiquement informée et vous contactera dans les plus brefs délais.</div>
          </div>
        </AlertMessage>
      )}
      {opcoRecord?.errors.length == 0 && ["ERROR-CERFA-UPLOAD", "ERROR-CONTRACT-UPLOAD", "ERROR-CONVENTION-UPLOAD", "FORBIDDEN"].includes(opcoRecord?.opcoStatus) && (
        <AlertMessage>
          <div className={cx(global.fracjb, css({ width: "100%" }))}>
            <div className={global.alertErrorText}>Les erreurs ont été corrigées, vous devez procéder à la <strong>re-génération du contrat</strong></div>
            <Button className={classes.errorButton} onClick={() => setGenerate(true)}>Re-générer</Button>
          </div>
        </AlertMessage>
      )}
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  errorButton: {
    height: 30,
    backgroundColor: "#f50057",
    color: "white",
    fontWeight: 500,
    padding: "0 14px",
    "&:hover": {
      backgroundColor: "#f50057",
    },
  },
});

export default Informations;